"use client";

import { useTranslations } from "use-intl";

/**
 * "Working…" in the till's language, for a button that is waiting.
 *
 * A component rather than a hook call inside `Button.tsx`, which carries no `"use client"` and is
 * imported from server-rendered pages as well.
 */
export function WorkingLabel() {
  const t = useTranslations("common");
  return <>{t("working")}</>;
}
